import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class TipoMermaService {
  /**
   * Obtiene todos los tipos de merma
   */
  async getAll() {
    return await fetchWrapper.get(`${ruta}/tipo-mermas`);
  }

  /**
   * Crea un nuevo tipo de merma
   * @param {Object} datos - Objeto con descripcion y estado
   */
  async create(datos) {
    return await fetchWrapper.post(`${ruta}/tipo-mermas`, datos);
  }

  /**
   * Actualiza un tipo de merma existente
   * @param {Object} tipoMerma - Objeto con los datos actualizados y el id
   */
  async update(tipoMerma) {
    return await fetchWrapper.put(
      `${ruta}/tipo-mermas/${tipoMerma.id}`,
      tipoMerma
    );
  }

  /**
   * Elimina un tipo de merma
   * @param {Number} id - ID del tipo de merma
   */
  async delete(id) {
    return await fetchWrapper.delete(`${ruta}/tipo-mermas/${id}`);
  }

  /**
   * Obtiene los tipos de merma id y name para combo
   */
  async getTipoMermaCombo() {
    return await fetchWrapper.get(`${ruta}/tipo-mermas/getTipoMermaCombo`);
  }
}
